<ul *ngIf="!initialProduct" class="nav nav-tabs">
    <li *ngFor="let tab of TabList" class="nav-item" [ngClass]="{'current-tab': currentFocusOn === tab}" (click)="changeTab(tab)">
      <a class="nav-link tab-link" >
        {{tab}}
      </a>
    </li>
</ul>

<ag-grid-angular #agGrid class="ag-theme-alpine" [columnDefs]="columnDefs" rowSelection="multiple"
  [defaultColDef]="defaultColDef" [pagination]="true" [suppressRowClickSelection]="true"
  (gridReady)="onGridReady($event)" [gridOptions]="gridOptions" style="height: 80vh" [enableCellTextSelection]="true"
  (sortChanged)="sortChanged($event)">
</ag-grid-angular>